import { render, staticRenderFns } from "./laporan.vue?vue&type=template&id=5c4a80f4&scoped=true"
import script from "./laporan.vue?vue&type=script&lang=js"
export * from "./laporan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a80f4",
  null
  
)

export default component.exports